import { Component, Inject } from '@angular/core';
import { SaveBtn } from '@shared/components/save-btn/save-btn.component';
import { CancelBtn } from '@shared/components/cancel-btn/cancel-btn.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogAction } from '@features/dashboard/components/alert/enums/dialogAction';

@Component({
  selector: 'app-base-dialog',
  imports: [SaveBtn, CancelBtn],
  templateUrl: './base-dialog.component.html',
  styleUrl: './base-dialog.component.scss',
})
export class BaseDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string },
    public dialogRef: MatDialogRef<BaseDialogComponent>,
  ) {}
  handleSubmit() {
    this.dialogRef.close(DialogAction.SUBMIT);
  }

  handleCancel() {
    this.dialogRef.close(DialogAction.CANCEL);
  }
}
